export default __webpack_public_path__ + "static/media/12. General Vocab.73b93f62.pdf";